var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"headerFontSizeSmallBtn",attrs:{"disabled":_vm.disabled},on:{"click":_vm.toggleFontSize}},[_c('span',{staticClass:"inner"},[_vm._v("あ")])])}
var staticRenderFns = []

export { render, staticRenderFns }